export { ProjectKeys, AutoPlaySwitchText, GameBannerText, FloorText } from '../../../../translation-data';
